/** Cookie set on the landing page for pricing A/B; read on signup. */
export const PRICING_VARIANT_COOKIE = "ed_pricing_variant";

export function getPricingVariantFromDocumentCookie(): "a" | "b" | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|; )ed_pricing_variant=([^;]+)/);
  if (!m?.[1]) return null;
  const v = decodeURIComponent(m[1]).trim().toLowerCase();
  return v === "a" || v === "b" ? v : null;
}

export function setPricingVariantCookie(variant: "a" | "b", maxAgeSec = 60 * 60 * 24 * 180) {
  if (typeof document === "undefined") return;
  document.cookie = `${PRICING_VARIANT_COOKIE}=${variant};path=/;max-age=${maxAgeSec};SameSite=Lax`;
}
